import ControlModule from 'scripts/poppet/control-module';
import template      from 'templates/controlGenericStates.jst.html';
import { Vue }       from 'vue/defavue';

const selectors = {
	region     : '[data-region=generic-state-container]'
};
let vue ='';
export const ControlGenericStatesView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	expandedNavState  : 'unit:control:genericStates',
	compressedNavState : 'unit:control:overview',
	
	ui: {
		region: selectors.region,
	},
	
	className: function () {
		return this._getClassName( 'control-generic-states' );
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	/**
	 * Triggers when the html is rendered in the DOM.
	 * @void
	 */
	onDomRefresh: function () {
		let self = this;
		vue = new Vue( {
			el: '#generic-states',
			bb() {
				return {
					model: self.model,
				}
			},
			computed: {
				batteryVoltage: function () {
					if(this.model.vehicleBatteryVoltage){
						return 'success' === this.model.vehicleBatteryVoltage.status ? this.model.vehicleBatteryVoltage.value + ' V' :  this.model.vehicleBatteryVoltage.value
					}
					return '--'
				},
				batteryVoltageStatus: function () {
					return this.model.vehicleBatteryVoltage ? this.model.vehicleBatteryVoltage.status : ''
				},
				batteryLvl: function() {
					let batteryLevel = 'icon-battery-unknown';
					if(this.model.vehicleBatteryLevel && this.model.vehicleBatteryLevel.status === 'success'){
						switch(this.model.vehicleBatteryLevel.value) {
							case 'NORMAL':
								batteryLevel = 'icon-battery-full';
								break;
							case 'LOW':
								batteryLevel = 'icon-battery-normal';
								break;
							case 'CRITICAL':
								batteryLevel = 'icon-battery-low';
								break;
						}
					}
					return batteryLevel;
				}
			}
		} );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

});

export default  ControlGenericStatesView;
